import { defineMessages } from 'react-intl'

const scope = `procurify.accounts-payable.feature-sets.ReconciliationMatchView`

export default defineMessages({
  unmatchedTabLabel: {
    id: `${scope}.unmatchedTabLabel`,
    defaultMessage: 'Unmatched items',
  },
  matchedTabLabel: {
    id: `${scope}.matchedTabLabel`,
    defaultMessage: 'Matched items',
  },
  newItemButton: {
    id: `${scope}.newItemButton`,
    defaultMessage: 'New item',
  },
  importStatementButton: {
    id: `${scope}.importStatementButton`,
    defaultMessage: 'Import statement',
  },
  ccRowMenuAriaLabel: {
    id: `${scope}.ccRowMenuAriaLabel`,
    defaultMessage: 'Actions for {description}',
  },
  statementRowMenuAriaLabel: {
    id: `${scope}.statementRowMenuAriaLabel`,
    defaultMessage: 'Actions for {description}',
  },
  editItemMenuItem: {
    id: `${scope}.editItemMenuItem`,
    defaultMessage: 'Edit item',
  },
  viewAuditLogMenuItem: {
    id: `${scope}.viewAuditLogMenuItem`,
    defaultMessage: 'View audit log',
  },
  removeItemMenuItem: {
    id: `${scope}.removeItemMenuItem`,
    defaultMessage: 'Remove item',
  },
  duplicateItemMenuItem: {
    id: `${scope}.duplicateItemMenuItem`,
    defaultMessage: 'Duplicate item',
  },
  unmatchItemMenuItem: {
    id: `${scope}.unmatchItemMenuItem`,
    defaultMessage: 'Unmatch item',
  },
  createItemModalTitle: {
    id: `${scope}.createItemModalTitle`,
    defaultMessage: 'Create credit card item',
  },
  editItemModalTitle: {
    id: `${scope}.editItemModalTitle`,
    defaultMessage: 'Edit credit card item',
  },
  createStatementItemModalTitle: {
    id: `${scope}.createStatementItemModalTitle`,
    defaultMessage: 'Create statement item',
  },
  unmatchModalTitle: {
    id: `${scope}.unmatchModalTitle`,
    defaultMessage: 'Matched items',
  },
  unmatchCancelButton: {
    id: `${scope}.unmatchCancelButton`,
    defaultMessage: 'Cancel',
  },
  unmatchConfirmButton: {
    id: `${scope}.unmatchConfirmButton`,
    defaultMessage: 'Unmatch',
  },
  auditLogModalTitle: {
    id: `${scope}.auditLogModalTitle`,
    defaultMessage: 'Audit log',
  },
  importStatementModalTitle: {
    id: `${scope}.importStatementModalTitle`,
    defaultMessage: 'Reconcile account',
  },
  matchConfirmTitle: {
    id: `${scope}.matchConfirmTitle`,
    defaultMessage: 'Match without statement items',
  },
  matchConfirmContent: {
    id: `${scope}.matchConfirmContent`,
    defaultMessage:
      'No credit card statement items are selected. Do you want to match the selected Procurify item(s) without statement items?',
  },
  matchConfirmButton: {
    id: `${scope}.matchConfirmButton`,
    defaultMessage: 'Match',
  },
  matchConfirmCancelButton: {
    id: `${scope}.matchConfirmCancelButton`,
    defaultMessage: 'Cancel',
  },
})
